import { render, staticRenderFns } from "./ReferencePostContent.vue?vue&type=template&id=f90cb366&scoped=true&"
import script from "./ReferencePostContent.vue?vue&type=script&lang=js&"
export * from "./ReferencePostContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90cb366",
  null
  
)

export default component.exports